"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.convertVehicleUnits = convertVehicleUnits;
exports.emptyVehicle = void 0;
exports.getGeoFenceSet = getGeoFenceSet;
exports.getValue = getValue;
exports.inferIgnitionStatus = inferIgnitionStatus;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _immutable = _interopRequireDefault(require("immutable"));
var _round = _interopRequireDefault(require("lodash/round"));
var _shared = require("../selectors/shared");
const initHealth = (0, _freeze.default)({
  value: 'normal',
  time: null
});
const emptyVehicle = (0, _freeze.default)({
  vehicle_id: '',
  id: '',
  imei: '',
  vin: '',
  make: '',
  model: '',
  name: '',
  model_year: null,
  // null instead of an empty string like the rest?
  heading: 0,
  speed: 0,
  avg_speed: 0,
  max_speed: 0,
  overspeed: 0,
  odometer: 0,
  tenant_id: '',
  timestamp: '',
  idle_status: 'false',
  // Why is this "false"?
  location: {},
  location_uncertainty: 0,
  fuel_level: '',
  fuel_consumed: 0,
  fleet_id: '',
  fleet_name: '',
  distance_travelled: 0,
  ignition_status: 'off',
  activity_status: 'off',
  oil_level_status: 'Normal',
  // instead of 'off'?
  oil_life_remaining: 0,
  oil_level: 'okay',
  oil_temp: 'okay',
  odop: 0,
  series: '',
  coolant_temp: 'okay',
  // TODO: use indicators
  tire_pressure: 'okay',
  // TODO: use indicators
  service_required: 'off',
  needs_service: false,
  //is clearly duplicative of above, but didn't know about that property
  pid_plugged_in: 'plugged',
  //or 'unplugged'
  indicators: {
    tire_pressure_lamp: {
      front_left: {
        ...initHealth
      },
      front_right: {
        ...initHealth
      },
      rear_left: {
        ...initHealth
      },
      rear_right: {
        ...initHealth
      },
      rear_output_left: {
        ...initHealth
      },
      // DJ: what are these "output" lamps?
      rear_output_right: {
        ...initHealth
      }
    },
    brake_system_lamp: {
      ...initHealth
    },
    oil_pressure_lamp: {
      ...initHealth
    },
    ignition_lamp: {
      ...initHealth
    },
    diesel_exhaust_fluid_lamp: {
      ...initHealth
    },
    water_in_fuel_lamp: {
      ...initHealth
    },
    collision_warning_lamp: {
      ...initHealth
    },
    low_washer_fluid_lamp: {
      ...initHealth
    },
    traction_control_lamp: {
      ...initHealth
    },
    engine_warning_lamp: {
      ...initHealth
    },
    airbag_lamp: {
      ...initHealth
    },
    abs_lamp: {
      ...initHealth
    },
    engine_coolant_temperature_lamp: {
      ...initHealth
    },
    lane_departure_lamp: {
      ...initHealth
    },
    automatic_speed_limiter_lamp: {
      ...initHealth
    }
  }
});

// TODO: Unit test this
exports.emptyVehicle = emptyVehicle;
function convertVehicleUnits(vehicleData, converter) {
  // Converts incoming vehicle from the MQS and streaming service to its final
  // form

  // Convert speeds from m/s to km/h
  const km_meters = 1000;
  const hour_seconds = 60 * 60;
  if (vehicleData.speed) {
    vehicleData.speed = vehicleData.speed * hour_seconds / km_meters;
  }
  if (vehicleData.avg_speed) {
    vehicleData.avg_speed = vehicleData.avg_speed * hour_seconds / km_meters;
  }

  // Convert units to current unit system
  if (vehicleData.speed) {
    vehicleData.speed = converter.rate(vehicleData.speed);
  }
  if (vehicleData.avg_speed) {
    vehicleData.avg_speed = converter.rate(vehicleData.avg_speed);
  }
  if (vehicleData.fuel_level) {
    vehicleData.fuel_level = converter.vol(vehicleData.fuel_level);
  }
  if (vehicleData.odometer) {
    vehicleData.odometer = converter.dist(vehicleData.odometer);
  }

  // Pick preferred fields
  // Pick first of ["speed", "avg_speed", null] and convert to number
  vehicleData.speed = Number(vehicleData.speed || vehicleData.avg_speed) || null;
  // Pick first of ["fuel_level", null] and convert to number
  vehicleData.fuel_level = vehicleData.fuel_level ? typeof vehicleData.fuel_level === 'string' ? Number(vehicleData.fuel_level) : vehicleData.fuel_level : null;

  // Format numbers
  if (vehicleData.speed) {
    vehicleData.speed = Math.round(vehicleData.speed);
  }
  if (vehicleData.fuel_level) {
    vehicleData.fuel_level = (0, _round.default)(vehicleData.fuel_level, 1);
  }
  if (vehicleData.odometer) {
    vehicleData.odometer = Math.round(vehicleData.odometer);
  }
  // TODO: round location possibly

  return vehicleData;
}

/**
 * Compares a geo location point to a list of geoFences and returns a set of
 * geoFences in which the point resides.
 * @returns {Immutable.Set} of geo fence IDs
 */
function getGeoFenceSet(location = {}, geoFences) {
  let geoFenceSet = _immutable.default.Set().asMutable();
  if (location.lat && location.lon) {
    location.lng = location.lon;
    const gLocation = new google.maps.LatLng(location);
    for (let [geoFenceId, geoFence] of geoFences.entrySeq()) {
      const gf = _shared.sharedGeoFenceSelectors.run(geoFence);
      if (gf.get('gPoly')) {
        if (google.maps.geometry.poly.containsLocation(gLocation, gf.get('gPoly'))) {
          geoFenceSet.add(geoFenceId);
        }
      } else if (gf.get('gRect')) {
        if (gf.get('gBounds').contains(gLocation)) {
          geoFenceSet.add(geoFenceId);
        }
      } else if (gf.get('gCir')) {
        // gBounds isn't precious (it's an overfitting rectangle!), but it should filter most of the cases
        if (gf.get('gBounds').contains(gLocation) && google.maps.geometry.spherical.computeDistanceBetween(gf.get('gCir').getCenter(), gLocation) <= gf.get('gCir').getRadius()) {
          geoFenceSet.add(geoFenceId);
        }
      }
    }
  }
  return geoFenceSet;
}
function getValue(fieldVal) {
  if (fieldVal !== null && typeof fieldVal === 'object') {
    return fieldVal.value;
  }
  return fieldVal;
}
function inferIgnitionStatus(vehicle) {
  // FIXME: until ignition data is solid, infer from fuel_consumed (#137410295)
  const originalIgnitionStatus = vehicle.ignition_status;
  if (!originalIgnitionStatus || originalIgnitionStatus.toUpperCase() !== 'ON') {
    if (vehicle.fuel_consumed > 0) {
      return 'on';
    } else {
      return 'off';
    }
  }
  return originalIgnitionStatus;
}